import { isBoolean } from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { PENDING_CHANGES_ACTION_TYPE } from '../actions';

const initialState = {
  isChangesNotSaved: false,
  isChangesLoaded: false,
  hasPendingChangesByCurrentUser: false,
  pendingChangesAuthors: null,
  isProgramChangeRequired: false,
};

const pendingChangesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PENDING_CHANGES_ACTION_TYPE.SET_PENDING_CHANGES_DATA:
      return {
        ...state,
        isChangesNotSaved: payload.hasPendingChanges,
        isChangesLoaded: isBoolean(payload.hasPendingChanges),
        isProgramChangeRequired: payload.isProgramChangeRequired,
        hasPendingChangesByCurrentUser: payload.hasPendingChangesByCurrentUser,
        pendingChangesAuthors: payload.pendingChangesMadeByUsers,
      };

    case PENDING_CHANGES_ACTION_TYPE.CLEAR_PENDING_CHANGES_DATA:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default pendingChangesReducer;
